import { EditableCard } from "../../../components/editableCard.component";
import { TableCardPlaceholder } from "../../../components/placeholders.component";
import { ApiSchemaUser } from "../../../models/api";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";

type Props = {
  data: ApiSchemaUser | undefined;
  isValidating: boolean;
};

export const ContactInfoCard = (props: Props) => {
  const { userId } = useParams<{ userId: string }>();
  return (
    <EditableCard
      link={`${AppRouteUi.Users.Root()}/update/${userId}`}
      title="Information"
      isValidating={props.isValidating}
    >
      {props.isValidating ? (
        <TableCardPlaceholder rows={6} />
      ) : (
        <table className="w-100 ">
          {!!props.data?.companyName && (
            <tr>
              <td className="p-3 border-bottom pe-2">Company Name</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.companyName}
              </td>
            </tr>
          )}
          {!!props.data?.gender && (
            <tr>
              <td className="p-3 border-bottom pe-2">Gender</td>
              <td className="p-3 border-bottom ps-2">{props.data?.gender}</td>
            </tr>
          )}
          {!!props.data?.email && (
            <tr>
              <td className="p-3 border-bottom pe-2">Email Address</td>
              <td className="p-3 border-bottom ps-2">{props.data?.email}</td>
            </tr>
          )}
          {!!props.data?.phoneNumber && (
            <tr>
              <td className="p-3 border-bottom pe-2">Phone Number</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.phoneNumber}
              </td>
            </tr>
          )}
          {!!props.data?.address && (
            <tr>
              <td className="p-3 border-bottom pe-2">Address</td>
              <td className="p-3 border-bottom ps-2">{props.data?.address}</td>
            </tr>
          )}
        </table>
      )}
    </EditableCard>
  );
};
